import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';

export class FormsBase {
   submitted: Observable<boolean>;

   // this is a getter/setter to avoid a typescript error when overridding
   // a base class property with a getter/setter pair, which is sometimes
   // necessary on form components.
   set form(form: UntypedFormGroup) {
      this._form = form;
   }

   get form(): UntypedFormGroup {
      return this._form;
   }

   protected _form: UntypedFormGroup;

   // QMG-NGSTYLE-03 - Access Modifiers and Underscores
   // eslint-disable-next-line @typescript-eslint/naming-convention
   private _submitted = new BehaviorSubject<boolean>(false);

   constructor() {
      this.submitted = this._submitted.asObservable();
   }

   addFieldForDirtyControl<TInput>(
      fields: (keyof TInput)[],
      controlName: keyof TInput & string
   ): (keyof TInput & string)[];

   addFieldForDirtyControl<TInput>(
      fields: (keyof TInput)[],
      controlName: string,
      field: keyof TInput & string
   ): (keyof TInput & string)[];

   addFieldForDirtyControl(fields: string[], controlName: string, field: string = controlName): string[] {
      if ((this.form.get(controlName) as UntypedFormControl).dirty) {
         return [...fields, field];
      }
      return fields;
   }

   markAsUntouchedAndPristine(): void {
      this.form.markAsUntouched();
      this.form.markAsPristine();
   }

   markAsSubmitted(submitted = true): void {
      this._submitted.next(submitted);
   }
}
